import React, { useState, useRef, useEffect } from 'react'

import Field from '../../Field/Field'
import TextInput from '../../TextInput/TextInput'
import Textarea from '../../Textarea/Textarea'
import Tooltip from '../../Tooltip/Tooltip'
import FieldLabel from '../../FieldLabel/FieldLabel'
import Checkbox from '../../Checkbox/Checkbox'
import Help from '../../Help/Help'
import { getContentTypeFieldDataTestId, CONTENT_TYPE_FIELD_ACTION_IDS } from '../helper'
import ToggleSwitch from '../../ToggleSwitch/ToggleSwitch'
import { booleanTestIdFormatter } from './../../../utils/helpers'

const Title = (props: any) => {
  const { onChange, uniqueKey, schema, type, isNonLocalizable, hasNonLocalizablePlan } = props
  const [initialSchema, setSchema] = useState(schema)
  const { display_name, uid, field_metadata, error_messages = {} } = schema

  const displayNameRef: any = useRef(null)

  useEffect(() => {
    displayNameRef.current.focus()
  }, [displayNameRef])

  const onchange = () => {
    console.log("Title log");

    onChange && onChange(schema)

    setSchema({ ...schema })

  };

  const onDisplayNameChange = (event: any) => {

    schema.display_name = event.target.value

    if (!schema.error_details) {
      schema.error_details = {}
    }

    if (!schema.display_name.length) {
      schema.error_details = {
        ...schema.error_details,
        display_name: "Display Name cannot be empty"
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        display_name: ""
      }
      schema.error = Object.keys(schema.error_details).filter(fi => schema.error_details[fi].length).length ? true : false;
    }
    onchange()
  }
  const onPlaceholderChange = (event: any) => {
    field_metadata.placeholder = event.target.value
    onchange()
  }
  const onInstructionChange = (event: any) => {
    field_metadata.instruction = event.target.value
    onchange()
  }
  const onHelpTextChange = (event: any) => {
    field_metadata.description = event.target.value
    onchange()
  }
  const onMinChange = (event: any) => {
    schema.min = parseInt(event.target.value) || null

    if (!schema.error_details) {
      schema.error_details = {}
    }

    if (event.target.value.length && (schema.min <= 0 || (schema.min > schema.max))) {
      schema.error_details = {
        ...schema.error_details,
        min: "minimum value cannot be zero or larger than max value"
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        min: ""
      }
      schema.error = Object.keys(schema.error_details).filter(fi => schema.error_details[fi].length).length ? true : false
    }
    onchange()
  }
  const onMaxChange = (event: any) => {
    schema.max = parseInt(event.target.value) || null

    if (!schema.error_details) {
      schema.error_details = {}
    }

    if (event.target.value.length && (schema.max <= 0 || (schema.max < schema.min))) {
      schema.error_details = {
        ...schema.error_details,
        max: "max value cannot be lower than min value"
      }
      schema.error = true
    } else {

      schema.error_details = {
        ...schema.error_details,
        max: ""
      }
      schema.error = Object.keys(schema.error_details).filter(fi => schema.error_details[fi].length).length ? true : false
    }
    onchange()
  }
  const onValChnage = (event: any) => {
    schema.format = event.target.value
    onchange()
  }
  const onValErrChange = (event: any) => {
    if (schema.error_messages) {
      schema.error_messages.format = event.target.value
    } else {
      schema.error_messages = {
        format: event.target.value,
      }
    }
    onchange()
  }
  const onOptionChange = (event: any) => {
    if (event.target.name === `${uniqueKey}.nonLocalization`) {
      schema.non_localizable = event.target.checked
    }
    onchange()
  }

  if (type === 'basic') {
    return (
      <div className="FormFields">
        <Field>
          <FieldLabel testId="cs-form-field-title-name" version="v2" required htmlFor="displayName">
            Display Name
          </FieldLabel>
          <TextInput
            required
            version="v2"
            name={`${uniqueKey}.displayName`}
            value={display_name}
            onChange={onDisplayNameChange}
            inputRef={displayNameRef}
            error={schema.error && schema.error_details.display_name ? true : false}
            placeholder={props.t('content_type.save_content_type.body.fields.common_properties.placeholders.enter_value')}
            testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.TITLE_INPUT)}
          />
        </Field>
        <Field>
          <FieldLabel testId="cs-form-field-title-uid" version="v2" required htmlFor="uid">
            Unique ID
          </FieldLabel>
          <Help testId="cs-form-field-title-uid-helptext" type="basic" text="A unique ID for this field. This should not be same as the ID of any other field in this content type." />
          <TextInput version="v2" required name={`${uniqueKey}.uid`} value={uid} disabled error={schema.error && schema.error_details.uid ? true : false} placeholder={props.t('content_type.save_content_type.body.fields.common_properties.placeholders.enter_value')} />
        </Field>
        <Field>
          <FieldLabel testId="cs-form-field-title-placeholder" version="v2" htmlFor="placeholder">Placeholder Value</FieldLabel>
          <TextInput
            version="v2"
            name={`${uniqueKey}.placeholder`}
            value={field_metadata.placeholder || ''}
            onChange={onPlaceholderChange}
            placeholder={props.t('content_type.save_content_type.body.fields.common_properties.placeholders.enter_value')}
            testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.PLACEHOLDER_INPUT)}
          />
        </Field>
        <Field>
          <FieldLabel testId="cs-form-field-title-instruction-value" version="v2" htmlFor="instruction">Instruction Value</FieldLabel>
          <Help type="basic" text="Helps you add instructions for this field. The instructional text will appear below the field." />
          <Textarea
            version="v2"
            name={`${uniqueKey}.instruction`}
            value={field_metadata.instruction || ''}
            onChange={onInstructionChange}
            placeholder={props.t('content_type.save_content_type.body.fields.common_properties.placeholders.enter_value')}
            testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}
            id={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}
          />
        </Field>
        <Field>
          <FieldLabel testId="cs-form-field-title-help-text" version="v2" htmlFor="helpText">Help Text</FieldLabel>
          <Help type="basic" text="Provide additional info about the field. The help text will appear when the user hovers on the ‘?’ sign beside the field name." />
          <Textarea
            version="v2"
            name={`${uniqueKey}.helpText`}
            value={field_metadata.description || ''}
            onChange={onHelpTextChange}
            showCharacterCount={true}
            hideCharCountError={false}
            maxLength={256}
            placeholder={props.t('content_type.save_content_type.body.fields.common_properties.placeholders.enter_value')}
            // multiline={true}
            testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}
            id={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}
          />
        </Field>
      </div>
    )
  } else if (type === 'advanced') {
    return (
      <div className="FormFields">
        <Field>
          <FieldLabel testId="cs-form-field-title-number-char" version="v2" htmlFor="minMax">Number of Characters</FieldLabel>
          <div className="FormFields__group-fields">
            <TextInput
              type="number"
              width="medium"
              version="v2"
              name={`${uniqueKey}.minimum`}
              value={schema.min || ''}
              min="0"
              onChange={onMinChange}
              error={schema.error && schema.error_details.min ? true : false}
              placeholder={props.t('content_type.save_content_type.body.fields.common_properties.placeholders.min')}
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.MIN_NUMBER_OF_CHARACTERS_INPUT)}
            />
            <span className="FormFields__group-separator">to</span>
            <TextInput
              version="v2"
              width="medium"
              type="number"
              name={`${uniqueKey}.maximum`}
              value={schema.max || ''}
              min="1"
              onChange={onMaxChange}
              error={schema.error && schema.error_details.max ? true : false}
              placeholder={props.t('content_type.save_content_type.body.fields.common_properties.placeholders.max')}
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.MAX_NUMBER_OF_CHARACTERS_INPUT)}
            />
          </div>
        </Field>
        <Field>
          <FieldLabel testId="cs-form-field-title-validation-regex" version="v2" htmlFor="validation">Validation (Regex)</FieldLabel>
          <TextInput
            version="v2"
            name={`${uniqueKey}.validation`}
            // value={field_metadata.format || ''}
            value={schema && schema.format ? schema.format : ''}
            onChange={onValChnage}
            placeholder={props.t('content_type.save_content_type.body.fields.common_properties.placeholders.enter_value')}
            testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.VALIDATION_REGEX_INPUT)}
          />
        </Field>
        <Field>
          <FieldLabel testId="cs-form-field-title-validation-err-msg" version="v2" htmlFor="validationErrMsg">Validation Error Message</FieldLabel>
          <TextInput
            name={`${uniqueKey}.validationErrMsg`}
            version="v2"
            value={
              schema.error_messages
                ? schema.error_messages.format
                  ? schema.error_messages.format
                  : ''
                : ''
            }
            onChange={onValErrChange}
            placeholder={props.t('content_type.save_content_type.body.fields.common_properties.placeholders.enter_value')}
            testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.VALIDATION_ERROR_MESSAGE_INPUT)}
          />
        </Field>
        {hasNonLocalizablePlan ?
          <Field>
            <FieldLabel className='mb-8' testId="cs-form-field-title-options" version="v2" htmlFor="options">Options</FieldLabel>
            <div className="FormFields__selection-wrapper">
              <div className='ToggleWrap'>
              {isNonLocalizable ?
                <Tooltip position="top" content="Available only if there are multiple languages in your stack.">
                    <ToggleSwitch
                      testId={booleanTestIdFormatter("cs-ct-field-title-non-localizable", schema.non_localizable)}
                      label="Non-localizable"
                      name={`${uniqueKey}.nonLocalization`}
                      checked={schema.non_localizable}
                      labelPosition="right"
                      onChange={onOptionChange}
                      labelColor="secondary"
                      disabled={isNonLocalizable}
                    />
                </Tooltip>
                :
                  <ToggleSwitch
                    testId={booleanTestIdFormatter("cs-ct-field-title-non-localizable", schema.non_localizable)}
                    label="Non-localizable"
                    name={`${uniqueKey}.nonLocalization`}
                    checked={schema.non_localizable}
                    labelPosition="right"
                    onChange={onOptionChange}
                    labelColor="secondary"
                    disabled={isNonLocalizable}
                  />
                // <Checkbox
                //   testId="cs-ct-field-title-non-localizable"
                //   name={`${uniqueKey}.nonLocalization`}
                //   text="Non-localizable"
                //   checked={schema.non_localizable}
                //   onChange={onOptionChange}
                //   disabled={isNonLocalizable}
                // />
              }
              </div>
              <div className="nl-note mt-8" data-test-id='cs-ct-field-title-non-localizable-description'>If enabled, editing this field is restricted in localized entries. The field will use the value of the master-language entry in all localized entries.</div>
            </div>
          </Field>
          : null}
      </div>
    )
  }
}

export default React.memo(Title)
